import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { homesReducers } from './homes.reducer';
import { HomesEffects } from './homes.effect';
import { HomesFacade } from './homes.facade';
import { HomesService } from './homes.service';

@NgModule({
  imports: [StoreModule.forFeature('homes', homesReducers), EffectsModule.forFeature([HomesEffects])],
  providers: [HomesService, HomesFacade],
})
export class HomesModule {}
